<div class="deleteModelContainer">
  <div class="deleteIcon"><img src="../../../../assets/Images/cancel.png" alt="delete" /></div>
  <div class="sureText" *ngIf="!modelNotDeleted">Are you sure?</div>
  <div class="sureText" *ngIf="modelNotDeleted">Sorry!</div>
  <div class="sureMsg" *ngIf="!modelNotDeleted">
    Do you really want yo delete thease models? This process can not be undone.
  </div>
  <div class="sureMsg" *ngIf="modelNotDeleted">
    You are not authorized to delete below models. Please contact administrator.
    <ul class="notDelModels"><li *ngFor="let item of notDeletedModel">{{item}}</li></ul>
  </div>
  <div class="deleteButtons">
    <div class="cancelDelete" *ngIf="!modelNotDeleted" (click)="onCancelClick()" (keydown)="onCancelClick();">Cancel</div>
    <div class="sureDelete" *ngIf="!modelNotDeleted" (click)="onDeleteClick()" (keydown)="onDeleteClick();">Delete</div>
    <div class="okaycancelDelete" *ngIf="modelNotDeleted" (click)="onOkayClick()" (keydown)="onOkayClick();">Ok</div>
    <div class="clear"></div>
  </div>
</div>

